import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { UpsertQRModal } from "modules/campaigns/components/Sections/triggers/qr/UpsertQRModal"
import { useQRByIdQuery } from "modules/campaigns/hooks/sections/qr/useQRByIdQuery"
import { SearchSchema } from "./route"

export const Route = createFileRoute("/_base/_auth/settings/channels/qr/$id")({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate()
  const { data, isPending } = useQRByIdQuery({ id })

  function onClose() {
    navigate({ to: "/settings/channels/qr", search: SearchSchema.parse(search) })
  }

  return <UpsertQRModal data={data} isPending={isPending} onClose={onClose} />
}
